import React from 'react';

import PropTypes from 'prop-types';

import PlusIcon from '~/icons/components/PlusIcon';
import { Link } from '~/techstyle-shared/next-routes';
import {
  SkeletonLine,
  useBreakpoint,
} from '~/techstyle-shared/react-components';

import useCioBrowseAndGqlProducts from '../../hooks/useCioBrowseAndGqlProducts';

const ProductCardSwatchesMobile = ({
  swatches = [],
  activeProductId,
  setActiveProductId = () => {},
  activeProductPdpLink,
}) => {
  const { isRelatedProductsLoading } = useCioBrowseAndGqlProducts();
  const { matches } = useBreakpoint('(max-width: 1025px)');
  const maxSwatchesToRender = matches ? 4 : 5;

  if (isRelatedProductsLoading) {
    return (
      <div className="flex flex-wrap gap-[4px] my-[8px]">
        {Array.from({ length: 6 }, (_, index) => (
          <SkeletonLine
            key={index}
            style={{
              width: '32px',
              height: '32px',
              borderRadius: '50%',
              border: '1px solid #ccc',
            }}
          />
        ))}
      </div>
    );
  }

  const isActive = (productId) => {
    return productId === activeProductId;
  };

  return (
    <div className="flex flex-wrap gap-[4px] my-[8px]">
      {swatches?.slice(0, maxSwatchesToRender).map((swatch) => (
        <button
          type="button"
          key={swatch?.productId}
          onClick={() => {
            if (swatch?.productId !== activeProductId) {
              setActiveProductId(swatch?.productId);
            }
          }}
        >
          <img
            key={swatch?.productId}
            className={`w-[32px] h-[32px] rounded-full border${
              isActive(swatch?.productId)
                ? 'border-black border-4'
                : 'border-gray-300 border-1'
            }`}
            src={swatch?.url}
            alt={swatch?.label}
            title={swatch?.label}
          />
        </button>
      ))}
      {swatches.length > 5 && (
        <Link href={activeProductPdpLink}>
          <a className="w-[32px] h-[32px] flex items-center justify-center">
            <PlusIcon size={26} />
          </a>
        </Link>
      )}
    </div>
  );
};

ProductCardSwatchesMobile.propTypes = {
  activeProductId: PropTypes.string,
  activeProductPdpLink: PropTypes.string,
  setActiveProductId: PropTypes.func,
  swatches: PropTypes.arrayOf(
    PropTypes.shape({
      productId: PropTypes.string.isRequired,
      url: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    })
  ),
};

export default ProductCardSwatchesMobile;
